<script setup>
import { getCurrentInstance, computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const { $toast } = getCurrentInstance().appContext.config.globalProperties;

defineOptions({
  name: 'ActionAgentItem'
});

const props = defineProps({
  actionName: {
    type: String,
    default: ''
  },
  hiddenLabel: {
    type: Boolean,
    default: false
  },
  url: {
    type: String,
    required: true
  },
  isEnoughAttrs: {
    type: Boolean,
    default: () => false
  }
});

const getURL = computed(() => {
  if (!props.isEnoughAttrs) {
    return t('message.errorValidateAgent', {
      action: `{${props.actionName}}`,
      attMissing: `{${[t('label.macAddr'), t('label.osType')].join(
        ` ${t('label.or').toUpperCase()} `
      )}}`
    });
  }

  return props.url;
});

const handleCopy = () => {
  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);
  textarea.value = props.url;
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  $toast.open(t('toast.agentManagement.copied'));
};
</script>

<template>
  <div class="agent-action">
    <div v-if="actionName && !hiddenLabel" class="agent-action__action">{{ props.actionName }}</div>
    <div class="agent-action__url">
      <div class="text" :class="{ invalid: !isEnoughAttrs }">{{ getURL }}</div>

      <lego-icon
        v-if="isEnoughAttrs"
        @click="handleCopy"
        v-lego-tooltip="t('label.copy')"
        class="icon"
        :iconType="'line'"
        :icon="'copy_path'"
        :size="16"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.agent-action {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &__action {
    width: 68px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    font-weight: 500;
  }
  &__url {
    flex: 1;
    background: #f7f7f8;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    padding: 12px 16px;
    width: 100%;
    overflow: auto;

    .text {
      color: #2e3138;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      word-break: break-word;

      &.invalid {
        color: #fb4b57;
      }
    }

    .icon {
      cursor: pointer;

      &:hover :deep(.lego-icon) {
        color: #22252a !important;
      }
    }
  }
}
</style>
